import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'mfp-modal-header',
  templateUrl: './modal-header.component.html',
  styleUrls: ['./modal-header.component.scss']
})
export class ModalHeaderComponent {
  @Input() title = '';

  @Output() closeClick = new EventEmitter();

  constructor() {}

  close() {
    this.closeClick.emit();
  }
}
